// Numeric constants
export const FIRST_INDEX = 0;
export const FIRST_ELEMENT = 0;
export const SECOND_ELEMENT = 1;
export const TOOLTIP_TIMEOUT = 150;
export const NULL_VALUE = 0;
export const SINGLE_RECORD = 1;

// Text color mapping for mismatch severity
export const TEXT_COLORS = {
  CRITICAL: "text-red-900 dark:text-red-500",
  HIGH: "text-red-600 dark:text-red-400",
  MEDIUM: "text-red-400 dark:text-red-200",
  LOW: "text-yellow-400 dark:text-yellow-200",
};

// Child row source type colors
export const SOURCE_COLORS = {
  Source: "text-green-500 dark:text-green-400",
  Destination: "text-red-500 dark:text-red-400",
};
